import { LOCAL_API_BASE_URL, PLATFORM_HOSTS_PATH, PLATFORM_VALIDATION_PATH } from '@/lib/constants';
export function getPlatformValidationUrl(): string {
	return `${getApiBaseUrl()}${PLATFORM_VALIDATION_PATH}`;
}

export function getPlatformHostsUrl(): string {
	return `${getApiBaseUrl()}${PLATFORM_HOSTS_PATH}`;
}

function getApiBaseUrl(): string {
	const configured = process.env.BUN_PUBLIC_API_BASE_URL;
	const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
	const baseUrl = configured || (isLocal ? LOCAL_API_BASE_URL : '');
	return baseUrl.replace(/\/$/, '');
}
